'use strict';
angular.module('webAgro1App')
  //eslint-disable-next-line
  .directive('agroLabelHistorico', function() {
    return {
      restrict: 'A',
      scope: {
        historico: '='
      },
      compile: function compile() {
        return {
          //eslint-disable-next-line
          post: function postLink(scope, element) {
            const historico = scope.historico;
            let classe = null;
            if (historico.situacao === 'neutro') {
              classe = 'muted';
            } else if (historico.situacao === 'equilibrio') {
              classe = 'equilibrio';
            } else if (historico.situacao === 'alto_equilibrio') {
              classe = 'alto_equilibrio';
            } else if (historico.situacao === 'controle') {
              classe = 'controle';
            } else if (historico.situacao === 'emergencia') {
              classe = 'alerta';
            } else if (historico.situacao === 'alerta') {
              classe = 'alerta';
            } else if (historico.situacao === 'extremo') {
              classe = 'extremo';
            }

            element.addClass('label-historico text-white label').addClass(`bg-${ classe }`);
            element.append(historico.tipo_to_pt_br);
          }
        };
      }
    };
  });
